import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { adminsAccessRoles } from './access';

export const adminsRoutes: RouteObject[] = [
  {
    path: 'admins',
    async lazy() {
      const { AdminsPage } = await import('./pages/AdminsPage');
      return { Component: AdminsPage };
    },
    handle: defineHandle({
      roles: [...adminsAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.admins',
    }),
  },
  {
    path: 'admins/:authId',
    async lazy() {
      const { AdminDetailPage } = await import('./pages/AdminDetailPage');
      return { Component: AdminDetailPage };
    },
    handle: defineHandle({
      roles: [...adminsAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.admins',
    }),
  },
];
